<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta (Foto)</label>
      <input
        class="q-input"
        :class="{ 'q-input--error': question.error }"
        type="text"
        placeholder="Escribe la instrucción (ej. Sube fotografias de...)"
        v-model="question.texto"
      />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-inline-row">
      <div class="q-row" style="min-width: 170px;">
        <label class="q-label">Fotos permitidas</label>
        <select class="q-input q-input--select" v-model.number="question.max_fotos" style="padding: 5px 8px;">
          <option :value="1">1 foto</option>
          <option :value="2">Hasta 2 fotos</option>
          <option :value="3">Hasta 3 fotos</option>
          <option :value="4">Hasta 4 fotos</option>
        </select>
      </div>

      <label class="q-check-row q-check-row--inline ml-auto">
        <input type="checkbox" v-model="question.obligatoria" />
        <span>Obligatoria</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "photo-question",
  created() {
    if (!this.question.max_fotos) {
      this.$set(this.question, 'max_fotos', 4);
    }
  },
  methods: {
    remove() { this.$emit("click"); },
    validateQuestion() { return this.validateEmptyQuestion(); },
    validateEmptyQuestion() {
      if (this.question.texto === "") { this.question.error = true; return false; }
      this.question.error = false; return true;
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 10px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-inline-row { display: flex; align-items: flex-end; gap: 14px; flex-wrap: wrap; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input {
  width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px;
  background: #f8fafc; color: #334155; font-size: 0.82rem;
  transition: border-color 0.15s, box-shadow 0.15s; outline: none;
  box-sizing: border-box;
}
.q-input:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; box-shadow: 0 0 0 3px rgba(239,68,68,0.1); }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row--inline { padding-bottom: 7px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #6366f1; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
</style>
